import { defineComponent as o, createBlock as l, openBlock as n, normalizeProps as p, guardReactiveProps as a, withCtx as s, renderSlot as m, createElementVNode as d } from "vue";
import i from "../CdrIcon.vue.mjs";
const f = /* @__PURE__ */ o({
  name: "StarStroke",
  __name: "star-stroke",
  props: {
    props: {
      type: Object
    }
  },
  setup(t) {
    return (r, e) => (n(), l(i, p(a(t.props)), {
      default: s(() => [m(r.$slots, "default"), e[0] || (e[0] = d("path", {
        role: "presentation",
        d: "M5.866 22.405l1.669-7.552L2 9.805l7.298-.66L12.176 2l2.878 7.147 7.298.659-5.535 5.048 1.669 7.552-6.31-4.007-6.31 4.006zm1.496-2.134l4.814-3.056 4.814 3.056-1.274-5.767L20 10.597l-5.645-.51-2.179-5.41-2.179 5.41-5.645.51 4.284 3.907-1.274 5.767z"
      }, null, -1))]),
      _: 3
    }, 16));
  }
});
export {
  f as default
};
